import { useEffect, useRef, useState, type CSSProperties } from 'react';
import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';
import { Centered } from '@sorare/core/src/atoms/layout/Centered';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  ANY_SPORT_SERIES_MARKET,
  ANY_SPORT_SERIES_MISSIONS_COLLECT,
  ANY_SPORT_SERIES_MISSIONS_DAILY,
  ANY_SPORT_SERIES_MISSIONS_PLAY,
  ANY_SPORT_SERIES_PLAY,
  ANY_SPORT_SERIES_SQUAD,
  ANY_SPORT_SERIES_TRAINING,
} from '@sorare/core/src/constants/__generated__/routes';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import { css } from '@sorare/css';

const PAGES_WITH_OWN_MOBILE_HEADER = [
  ANY_SPORT_SERIES_PLAY,
  ANY_SPORT_SERIES_SQUAD,
  ANY_SPORT_SERIES_MARKET,
  ANY_SPORT_SERIES_TRAINING,
  ANY_SPORT_SERIES_MISSIONS_COLLECT,
  ANY_SPORT_SERIES_MISSIONS_DAILY,
  ANY_SPORT_SERIES_MISSIONS_PLAY,
] as const;

const root = css`
  isolation: isolate;
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--c-rgb-black), 0.8);
    opacity: var(--scroll-percentage, 0);
  }
`;

export const TransparentMobileWebAppHeader = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPercentage(
        Math.min(
          1,
          Number((window.scrollY / (ref.current?.clientHeight || 1)).toFixed(2))
        )
      );
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (
    PAGES_WITH_OWN_MOBILE_HEADER.some(path =>
      matchAnySportPath(catchAll(path), pathname)
    )
  ) {
    return null;
  }

  return (
    <Vertical
      ref={ref}
      className={root}
      gap={0}
      style={{ '--scroll-percentage': scrollPercentage } as CSSProperties}
    >
      <Centered
        className="px-2 py-1"
        left={
          <SBHorizontal
            className="w-full empty:hidden"
            id="page-header-title"
          />
        }
      >
        <div className="flex" id="page-header-centered-item" />
      </Centered>
      <div id="page-header-second-row" />
    </Vertical>
  );
};
